import React from "react";
import styles from "./form.component.module.scss";
import { mockTrialRecords } from "./records.mock";
import { ExtendTrialFormChildrenProps } from "./form-wrapper";
import cn from "../../../../Utils/class-names.utils";
import { ApproveDenyButton } from "./approve-deny-button/approve-deny-button";
import { ClientDataBlock } from "./client-data-block/client-data-block";

interface FormComponentProps {
  formikProps: ExtendTrialFormChildrenProps;
  isSendRequestView?: boolean;
}

const FormComponent = ({ formikProps, isSendRequestView = true }: FormComponentProps) => {
  const { values, errors, handleDaysChange, handleReasonChange } = formikProps;

  return (
    <div className={styles.container}>
      <div className={styles.title}>{isSendRequestView ? "Extend Trial Period" : "Request"}</div>

      <div className={styles.section}>
        <div className={`${styles.sectionLabel} ${styles.sectionLabelMuted}`}>
          Records
        </div>

{isSendRequestView ? (
        <div className={styles.recordsList}>
          {mockTrialRecords.map((record) => (
            <div key={record.id} className={styles.recordsRow}>
              <div className={styles.recordsDates}>
                <p className={styles.recordsDatesText}>{record.dateRange}</p>

                <div className={styles.recordsStatus}>{record.status}</div>
              </div>

              <div className={styles.recordsSummary}>{record.summary}</div>
            </div>
          ))}
        </div>) : (
        <ClientDataBlock />
      )}
      </div>

      <div className={styles.section}>
        <div className={styles.sectionLabel}>Days to extend</div>
        <div className={styles.daysInputContainer}>
          <label htmlFor="number-input" className={styles.daysInputLabel}>
            <input
              id="number-input"
              type="text"
              inputMode="numeric"
              aria-label="Number input"
              className={cn(styles.daysInput, { [styles.daysInputError]: !!errors.days && values.days.length > 0 })}
              value={values.days}
              onChange={(e) => handleDaysChange(e.target.value)}
            />
          </label>

          <div className={styles.daysSuffixContainer}>
            <div className={styles.daysSuffixInner}>
              <span className={styles.daysSuffixText}>Day(s)</span>
            </div>
          </div>
        </div>
        {isSendRequestView && <p className={styles.helperText}>
          Maximum trial duration is 45 days. Extensions require approval.
        </p>}
      </div>

      {!isSendRequestView && (
        <div className={styles.section}>
          <div className={styles.buttonsContainer}>
            <ApproveDenyButton onClick={() => {}} />
            <ApproveDenyButton isApprove={false} onClick={() => {}} />
          </div>
        </div>
      )}

      <div className={styles.section}>
        <div className={styles.sectionLabel}>Reason</div>

        <textarea
          className={styles.reasonTextarea}
          placeholder="Type a reason..."
          rows={4}
          aria-label="Reason"
          value={values.reason}
          onChange={(e) => handleReasonChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default FormComponent;